<script setup>

import {ref} from "vue";
import ButtonTransparent from "../../buttons/buttonTransparent.vue";
import IconChevron from "../../icons/iconChevron.vue";

const emit = defineEmits(['open-in-slideout', 'confirm-delete']);

const props = defineProps({
    note: {
        type: Object,
        required: true,
    }
})

const previewing = ref(true);

const openInSlideout = (note) => {
    emit('open-in-slideout', note);
}
</script>

<template>
    <div>
        <div
            class="flex w-full justify-between"
        >
            <div class="relative flex items-center w-full cursor-pointer" @click="previewing = ! previewing">
                <div
                    class="w-full max-h-10 overflow-hidden cursor-pointer mt-1 mb-4 md:-mb-0 transition-all"
                    :class="previewing ? '' : 'opacity-0 translate-y-8 pointer-events-none select-none'"
                    v-html="note.note"
                ></div>
                <div class="absolute left-0 right-0 bottom-0 bg-gradient-to-b from-transparent to-white h-6 pointer-events-none"></div>
            </div>

            <div class="flex items-center justify-end -mt-2 md:mt-0.5">
                <i
                    v-if="note.has_attachment || note.attachment_url"
                    class="text-xs text-gray-500 fa-solid fa-paperclip mr-4 cursor-pointer"
                    @click="previewing = false"
                ></i>
                <div class="flex space-x-2">
                    <button-default
                        size="sm"
                        @click="openInSlideout(note)"
                    >
                        {{ _mft('shared:action.edit') }}
                    </button-default>

                    <button-default
                        size="sm"
                        @click="previewing = !previewing"
                    >
                        <icon-chevron
                            class="w-4 h-4 transition-transform"
                            :class="previewing ? '' : 'rotate-180'"
                        ></icon-chevron>
                    </button-default>
                </div>
            </div>

        </div>
        <div
            class="transition-all"
            :class="previewing ? '-translate-y-8 opacity-50 delay-75' : 'translate-y-0'"
        >
            <div v-if="! previewing">
                <p
                    class="whitespace-pre-line note-content"
                    v-html="note.note"
                ></p>
                <a
                    :href="note.attachment_url"
                    target="_blank"
                >
                    <img
                        v-if="note.attachment_url"
                        alt="Image"
                        :src="note.attachment_url"
                        class="w-48 h-auto"
                    />
                </a>
            </div>
        </div>
        <div
            class="px-4 -mx-4 -mb-3"
            :class="previewing ? '-mt-3 md:mt-0' : ''"
        >
            <div class="py-2 mt-2 border-t">
                <div>
                    <div class="flex justify-between items-center space-x-2">
                        <div class="block text-xs text-gray-400">
                            {{ note.created_at.user_tz || note.note_date }}
                        </div>
                        <div v-if="note.user" class="text-xs text-gray-400">
                            {{ note.user.name }}
                        </div>
                    </div>
                    <div class="block text-xxs text-gray-400 truncate">
                        <span v-if="note.created_at.user_tz !== note.updated_at.user_tz">
                            {{ _mft('shared:edited') }} {{ note.updated_at.user_tz }}
                        </span>
                        <span v-else>&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>

</style>
